import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import { Typography, ClickAwayListener } from '@material-ui/core'
import InfoOutlined from '@material-ui/icons/InfoOutlined'
function IconTooltip(props) {
  const [open, setOpen] = React.useState(false)
  const TooltipBox = withStyles((theme) => ({
    tooltip: {
      backgroundColor: 'white',
      color: 'rgb(120,120,120)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #00CED1',
      padding: 10
    }
  }))(Tooltip)
  const handleTooltipOpen = () => {
    if (window.innerWidth <= 768) {
      // Only trigger click handling on mobile view
      setOpen((prev) => !prev)
    }
  }
  const handleTooltipClose = () => {
    setOpen(false)
  }
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <span>
        <TooltipBox
          title={
            <React.Fragment>
              <Typography variant="h6">{props.tooltipShow}</Typography>
            </React.Fragment>
          }
          open={open || undefined} // undefined: default hover on desktop
        >
          <InfoOutlined
            style={{ color: '#F67131', fontSize: '25', ...props.style }}
            onClick={handleTooltipOpen} // Toggle tooltip only on mobile
          />
        </TooltipBox>
      </span>
    </ClickAwayListener>
  )
}
export default IconTooltip
